// src/components/ExperienceBox.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '../components/Button';

const ExperienceContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const Message = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

const Navigation = styled.div`
  margin-top: 10px;
`;

const ExperienceBox = ({ messages, autoplay = false, duration = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (autoplay) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
      }, duration);
      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [autoplay, duration, messages.length]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? messages.length - 1 : prevIndex - 1
    );
  };

  return (
    <ExperienceContainer>
      <Message>{messages[currentIndex]}</Message>
      <Navigation>
        <Button onClick={handlePrevious}>Previous</Button>
        <Button onClick={handleNext}>Next</Button>
      </Navigation>
    </ExperienceContainer>
  );
};

export default ExperienceBox;
